<template>
    
    <!-- <v-fab
        icon="mdi-phone"
        color="blue" 
        :href="'tel:+8056323960'" target="_blank"
        size="50"
        class="call-btn"
      /> -->

      <v-avatar size="50px"  class="call-btn" @click="goToCall">
      <v-img
        alt="Avatar"
        :src="callUsImage"
      ></v-img>
    </v-avatar>

    <v-avatar
        rounded="0"
        class="quick-btn"
        size="150px"
        @click="goToProduct"
      >
        <v-img :src="quickImage" cover ></v-img>
      </v-avatar>


      <v-fab
        icon="mdi-cart"
        color="primary" @click="cartDialogue"
        size="50"
        class="cart-btn"
      />


     <v-fab
        icon="mdi-whatsapp"
        color="green" @click="goToWhatsApp"
        size="50"
        class="whatsapp-btn"
      />
      <v-fab
        icon="mdi-instagram"
        color="pink" @click="goToInstagram"
        size="50"
        class="insta-btn"
      />

      <v-fab
        icon="mdi-facebook"
        color="blue-darken-4" @click="goToFacebook"
        size="50"
        class="facebook-btn"
      />

    <v-footer theme="dark" padless>
      <v-card flat tile class="white--text text-center footer-card">
        <v-card-text class="white--text pt-0">
           <v-row justify="space-around" id="container" ref="container">
            <v-col cols="12" sm="3" md="3" class="text-center pa-5">
              <div v-html="getFooterDetails.address1"></div> 
              <v-divider></v-divider>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="12" sm="3" md="3" class="text-center pa-5">
              <div v-html="getFooterDetails.address2"></div>
              <v-divider></v-divider>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="12" sm="3" md="3" class="text-center pa-5">
              <div v-html="getFooterDetails.address3"></div>
              <v-divider></v-divider>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="12" sm="3" md="3" class="text-center pa-5">
              <div v-html="getFooterDetails.address4"></div>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="text-center">
              <img
                v-if="getFooterDetails.qrcode1"
                alt="QR code"
                :src="
                  imageUrl + 'storage/qrcode/' + getFooterDetails.qrcode1
                "
                height="250"
                contain
              />
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="12" sm="3" md="3" class="text-center">
              <img
                v-if="getFooterDetails.qrcode2"
                alt="QR code"
                :src="
                  imageUrl + 'storage/qrcode/' + getFooterDetails.qrcode2
                "
                height="250"
                contain
              />
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="12" sm="3" md="3" class="text-center">
              <img
                v-if="getFooterDetails.qrcode3"
                alt="QR code"
                :src="
                  imageUrl + 'storage/qrcode/' + getFooterDetails.qrcode3
                "
                height="250"
                contain
              />
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="12" sm="3" md="3" class="text-center">
              <img
                v-if="getFooterDetails.qrcode4"
                alt="QR code"
                :src="
                  imageUrl + 'storage/qrcode/' + getFooterDetails.qrcode4
                "
                height="250"
                contain
              />
            </v-col> 
          </v-row> 
        </v-card-text>
  
        <v-divider></v-divider>
  
        <v-divider></v-divider>

  
        <v-card-text class="white--text text-center">
          {{ new Date().getFullYear() }} — <strong>Sasicrackers  </strong>
          <!-- <a @click="websiteOpen" class="font-weight-bold white--text footer-link">Developed By Smartxpose Technologies</a> -->
        </v-card-text>
      </v-card>
    </v-footer>
  </template>
  
  <style>
  .footer-card {
    width: 100%;
  }
  
  .footer-link {
    cursor: pointer;
  }
.cart-btn{
  position: fixed;
  bottom: 100px;
  right: 10px;
  cursor: pointer;
  z-index: 10;
  height: 110px !important;
}
.quick-btn{
  position: fixed;
  bottom: 25px;
  right: 10px;
  cursor: pointer;
  z-index: 10;
  height: 110px !important;
}
  .call-btn{
  position: fixed;
  bottom: 205px;
  left: 10px;
  cursor: pointer;
  z-index: 10;
  }
  .whatsapp-btn{
  position: fixed;
  bottom: 145px;
  left: 10px;
  z-index: 10;
  }
 .insta-btn{
  position: fixed;
  bottom: 85px;
  left: 10px;
  z-index: 10;
 }
 .facebook-btn{
  position: fixed;
  bottom: 25px;
  left: 10px;
  z-index: 10;
 }
  </style>
  
  <script>
  // @ is an alias to /src
  import { VUE_WEB_BASEURL,WEB_BASEURL } from "../utils/api";
  import { mapActions, mapGetters } from "vuex";
  import callUsImage from "../assets/call_us.jpeg";
  import quickImage from "../assets/quick_image.png";
  export default {
    props: ['cartQty'],
    name: "FooterSection",
    data: () => ({
      imageUrl: "",
      callUsImage:callUsImage,
      quickImage:quickImage,
    }),
    computed: {
      ...mapGetters(["getFooterDetails"]),
    },
    created() {
      this.fetchFooter();
      this.imageUrl = VUE_WEB_BASEURL;
    },
    methods: {
      ...mapActions(["fetchFooter"]),
    websiteOpen() {
      window.open("https://smartxpose.com/", "_blank");
    },
    goToProduct() {
      console.log('enter');
      window.location.href = WEB_BASEURL+'product'; 
    },
    goToCall() {
      // console.log(this.getFooterDetails.callno);
      window.location.href = 'tel:+'+this.getFooterDetails.callno; // Dial number
    },
    goToWhatsApp() {
      const phoneNumber = '+91'+this.getFooterDetails.whatsappno; // replace with your number
      const message = encodeURIComponent('Hello, I’d like to chat with you!');
      const url = `https://wa.me/${phoneNumber}?text=${message}`;
      window.open(url, '_blank');
    },
    goToInstagram() {
      const url = this.getFooterDetails.instagram;
      window.open(url, '_blank');
    },
    goToFacebook(){
      const url = this.getFooterDetails.facebook;
      window.open(url, '_blank');
    },
    cartDialogue(){
        console.log('enter');
        this.$emit("childEvent", { message: "Hello from child!" });
      }
    },
  };
  </script>
  